import { FC } from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import _ from 'lodash';
import { InputFieldConditionalRendering } from '../conditional-rendering/InputFieldConditionalRendering';

interface NormalDatepickerProps {
  label: string;
  fieldName: string;
  formik: any;
  minDate?: Date;
  maxDate?: Date;
  ddmmyy?: Array<'day' | 'month' | 'year'>;
  disabled?: boolean;
}
export const NormalDatepicker: FC<NormalDatepickerProps> = ({ label, fieldName, formik, minDate, maxDate, ddmmyy, disabled }) => {
  if (!ddmmyy) {
    ddmmyy = ['day', 'month', 'year'];
  }

  const errors = _.get(formik.errors, fieldName);
  const touched = _.get(formik.touched, fieldName);
  const rawValue = _.get(formik.values, fieldName);
  const dateValue = rawValue instanceof Date ? rawValue : typeof rawValue === 'string' && rawValue ? new Date(rawValue) : null;

  return (
    <InputFieldConditionalRendering fieldName={fieldName}>
      <DatePicker
        disabled={disabled}
        label={label}
        {...formik.getFieldProps(fieldName)}
        value={dateValue}
        onChange={(newValue: Date | null) => {
          if (newValue === null || newValue === undefined) formik.setFieldValue(fieldName, null);
          if (newValue !== null && newValue !== undefined) formik.setFieldValue(fieldName, new Date(newValue));
        }}
        minDate={minDate}
        maxDate={maxDate}
        views={ddmmyy}
        slotProps={{
          textField: {
            margin: 'normal',
            type: 'text',
            variant: 'outlined',
            fullWidth: true,
            error: touched && Boolean(errors),
            helperText: (touched && errors) ?? ' ',
            placeholder: 'DD.MM.YYYY',
            inputProps: { placeholder: 'DD.MM.YYYY', 'data-cy': fieldName + '-field' },
          },
        }}
      />
    </InputFieldConditionalRendering>
  );
};

export const CustomDatePicker: FC<{
  label: string;
  setValue: (value: Date) => void;
  value: Date;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
}> = ({ label, setValue, value, minDate, maxDate, disabled }) => {
  return (
    <DatePicker
      disabled={disabled}
      label={label}
      value={value}
      onChange={(newValue: Date | null) => {
        if (newValue === null || newValue === undefined) setValue(new Date());
        if (newValue !== null && newValue !== undefined) setValue(new Date(newValue));
      }}
      minDate={minDate}
      maxDate={maxDate}
      slotProps={{
        textField: {
          margin: 'normal',
          type: 'text',
          variant: 'outlined',
          fullWidth: true,
          placeholder: 'DD.MM.YYYY',
          inputProps: { placeholder: 'DD.MM.YYYY' },
        },
      }}
    />
  );
};
